import { Injectable } from '@angular/core';
import { WindowRef } from '@spartacus/core';

const KN_BR_CART_CONTEXT_STORAGE_KEY = 'kn-br-cart-context';

@Injectable({
  providedIn: 'root',
})
export class KnBrCartContextAdapter {
  constructor(private winRef: WindowRef) {}

  get() {
    if (this.winRef.localStorage) {
      const context = this.winRef.localStorage.getItem(KN_BR_CART_CONTEXT_STORAGE_KEY);
      if (context) {
        try {
          return JSON.parse(context);
        } catch (e) {}
      }
    }
    return null;
  }
  set(context: string) {
    if (this.winRef.localStorage) {
      this.winRef.localStorage.setItem(KN_BR_CART_CONTEXT_STORAGE_KEY, JSON.stringify(context));
    }
  }
  remove() {
    if (this.winRef.localStorage) {
      this.winRef.localStorage.removeItem(KN_BR_CART_CONTEXT_STORAGE_KEY);
    }
  }
}
